module.exports = __webpack_public_path__ + "static/media/MEDLI-2_B.20d4e10e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/MEDLI-2_B.jpg
// module id = 120
// module chunks = 0